module.exports = __webpack_public_path__ + "static/msLogo-46f71f573acdf57b33f1493644d1f120.png";